import React from 'react'
import { useTrans } from '@next-nx/hooks'
import { OffertaType } from '@next-nx/utils/types'
import { 
  CaratteristicheCategoria,  
  CaratteristicheAlimentazione,
  CaratteristicheKw,
  CaratteristicheCambio,
  CaratteristicheConsumi,
  CaratteristicheEmissioni,
  CaratteristicheOptional,
  CaratteristicheNote
} from '@next-nx/shared-ui/icons'
import styles from './ProdottoCaratteristiche.module.sass'

interface Props {
  offerta: OffertaType
  className?: string
}

const ProdottoCaratteristiche = (props: Props) => {

  const { 
    offerta,
    className = '',
  } = props

  const t = useTrans()
  const caratteristiche = [
    { chiave: 'categoria', icon: <CaratteristicheCategoria />, label: t('Categoria'), value: offerta.veicolo.categoria?.nome, },
    { chiave: 'alimentazione', icon: <CaratteristicheAlimentazione />, label: t('Alimentazione'), value: offerta.veicolo.alimentazione, },
    { chiave: 'kw', icon: <CaratteristicheKw />, label: t('KW'), value: offerta.veicolo.potenzaKw, },
    { chiave: 'cambio', icon: <CaratteristicheCambio />, label: t('Cambio'), value: offerta.veicolo.cambio, },
    { chiave: 'consumi', icon: <CaratteristicheConsumi />, label: t('Consumi'), value: offerta.veicolo.consumi, },
    { chiave: 'emissioni', icon: <CaratteristicheEmissioni />, label: t('Emissioni'), value: offerta.veicolo.ecoImpactCo2, },
    { chiave: 'optional', icon: <CaratteristicheOptional />, label: t('Optional'), value: offerta.veicolo.optional, },
    { chiave: 'note', icon: <CaratteristicheNote />, label: t('Note'), value: offerta.note, },
  ]

  return offerta ? (
    <div className={`${styles.root} ${className}`}>
      <p className={styles.title}>{t("Caratteristiche")}</p>
      <div className={styles.list}>
        {caratteristiche.filter(x => x.value).map(x => (
          <div className={styles.item} key={x.chiave}>
            <span className={styles.icon}>{x.icon}</span>
            <div className={styles.content}>
              <span className={styles.label}>{x.label}</span>
              <span className={styles.value}>{x.value}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  ) : <></>
}

export default ProdottoCaratteristiche
